import type { FaireProductEntity } from "../../entity_types/product";

export const p_c2z7ruafqr: FaireProductEntity = {
  token: "p_c2z7ruafqr",
  type: "product",
  name: "Facial Brush Bamboo Handle",
  brandToken: "b_ttb2n52ngz",
  brandName: "BeNat",
  imageUrl:
    "https://cdn.faire.com/fastly/fd04c5789fa1b98ad66d37fdd915267cc3ff49403769bd9d356988e742039734.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4a2795ff49dbca71e8e03435e1e18e0574978cb172b65611ed333791639ac4c8.png",
    "https://cdn.faire.com/fastly/437a98718868e177443e1eff13a234418ed20fb1567156b7bacca6d5fdd8f728.jpeg",
    "https://cdn.faire.com/fastly/7ff6601ee8236a324d0e48b45e48e398eecafba3074cc27bb93edf9a1ec8adaa.jpeg",
    "https://cdn.faire.com/fastly/3c2eabb2dfbdd9ee01640c205679213f9a85bbcb92fc4348a6adb3c4873c1e7e.jpeg",
    "https://cdn.faire.com/fastly/8f60146f6bae4eeeccac0bca06a25603a5306915b4de5fbc65a80e906230f25b.jpeg",
    "https://cdn.faire.com/fastly/a76292ef80b004d60a2c456ca7d4471f38eceb77cd671eb2b9771f4a8cd46d68.jpeg",
    "https://cdn.faire.com/fastly/ed2fb48bdb35510383b064baeb612b7c3b8f2cb530dc2a9bf0d1efecab6a5e37.jpeg",
    "https://cdn.faire.com/fastly/55059d9c79e3757d46711c3e56de7007a269b5e87d5a420c3e9ec6790e56a00d.jpeg",
  ],
  priceDollars: 7.61,
  description:
    "Our awesome superfine bamboo fibers facial brush will help you exfoliate dead facial skin cells while brightening your skin and keeping it firm.\n\nGently cleans pores and removes blackheads, oil, and other dirt. It is soft and gentle on delicate skin while effective in cleaning.\n\nIts massaging action will leave your face looking clean and fresh. You will love it!\nThis brush has a strong wooden handle and naturally derived bristles.\n\nNatural. Eco-friendly. Low-waste. Non-electric. A must-have in your skincare environmental-friendly products collection!\n \nGentle superfine bristles for sensitive skin. This brush uses extra soft bamboo fibers. Non-electric, no need for batteries or electricity, scrub and wash. Soften your skin by cleaning your face daily and removing oil and sweat buildup. Apply cleaners to wet face.\n\n Gently brush your face in a circular motion. Eco-friendly, low-waste, bamboo wooden handler and naturally derived bristles. You will love it!",
  tags: [],
  msrpDollars: 15.21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:39.355Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
